/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { PspRequestResponseDto } from './PspRequestResponseDto';
import {
    PspRequestResponseDtoFromJSON,
    PspRequestResponseDtoFromJSONTyped,
    PspRequestResponseDtoToJSON,
    PspRequestResponseDtoToJSONTyped,
} from './PspRequestResponseDto';

/**
 * 
 * @export
 * @interface PaymentEventDto
 */
export interface PaymentEventDto {
    /**
     * 
     * @type {PaymentEventDtoEventCodeEnum}
     * @memberof PaymentEventDto
     */
    eventCode: PaymentEventDtoEventCodeEnum;
    /**
     * 
     * @type {PaymentEventDtoNewStateEnum}
     * @memberof PaymentEventDto
     */
    newState: PaymentEventDtoNewStateEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentEventDto
     */
    payload?: string;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof PaymentEventDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof PaymentEventDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {Array<PspRequestResponseDto>}
     * @memberof PaymentEventDto
     */
    pspRequestsResponses: Array<PspRequestResponseDto>;
    /**
     * 
     * @type {Date}
     * @memberof PaymentEventDto
     */
    created?: Date;
}


/**
 * @export
 */
export const PaymentEventDtoEventCodeEnum = {
    INITIATE: 'INITIATE',
    INITIATE_FAILED: 'INITIATE_FAILED',
    SEND_FOR_PAYMENT: 'SEND_FOR_PAYMENT',
    REDIRECT_SHOPPER: 'REDIRECT_SHOPPER',
    PAYMENT_CANCELLED: 'PAYMENT_CANCELLED',
    COMPLETE_WITHOUT_PAYMENT: 'COMPLETE_WITHOUT_PAYMENT',
    AUTHORISE: 'AUTHORISE',
    AUTHORISE_FAILED: 'AUTHORISE_FAILED',
    AUTHORISE_SUCCEEDED: 'AUTHORISE_SUCCEEDED',
    CAPTURE: 'CAPTURE',
    CAPTURE_SUCCEEDED: 'CAPTURE_SUCCEEDED',
    CAPTURE_FAILED: 'CAPTURE_FAILED',
    REFUND: 'REFUND',
    REFUND_SUCCEEDED: 'REFUND_SUCCEEDED',
    REFUND_FAILED: 'REFUND_FAILED',
    STATE_UNDETERMINED: 'STATE_UNDETERMINED',
    STATE_IN_PROGRESS: 'STATE_IN_PROGRESS',
    MANUAL_STATE_OVERRIDE: 'MANUAL_STATE_OVERRIDE'
} as const;
export type PaymentEventDtoEventCodeEnum = typeof PaymentEventDtoEventCodeEnum[keyof typeof PaymentEventDtoEventCodeEnum];

/**
 * @export
 */
export const PaymentEventDtoNewStateEnum = {
    INITIATING: 'INITIATING',
    AWAITING_PAYMENT: 'AWAITING_PAYMENT',
    AUTHORISING: 'AUTHORISING',
    AUTHORISED: 'AUTHORISED',
    CAPTURING: 'CAPTURING',
    CAPTURED: 'CAPTURED',
    PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
    FULLY_REFUNDED: 'FULLY_REFUNDED',
    FAILED: 'FAILED',
    UNKNOWN: 'UNKNOWN',
    REFUNDING: 'REFUNDING'
} as const;
export type PaymentEventDtoNewStateEnum = typeof PaymentEventDtoNewStateEnum[keyof typeof PaymentEventDtoNewStateEnum];


/**
 * Check if a given object implements the PaymentEventDto interface.
 */
export function instanceOfPaymentEventDto(value: object): value is PaymentEventDto {
    if (!('eventCode' in value) || value['eventCode'] === undefined) return false;
    if (!('newState' in value) || value['newState'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('pspRequestsResponses' in value) || value['pspRequestsResponses'] === undefined) return false;
    return true;
}

export function PaymentEventDtoFromJSON(json: any): PaymentEventDto {
    return PaymentEventDtoFromJSONTyped(json, false);
}

export function PaymentEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentEventDto {
    if (json == null) {
        return json;
    }
    return {
        
        'eventCode': json['eventCode'],
        'newState': json['newState'],
        'payload': json['payload'] == null ? undefined : json['payload'],
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentMethod': json['paymentMethod'],
        'pspRequestsResponses': ((json['pspRequestsResponses'] as Array<any>).map(PspRequestResponseDtoFromJSON)),
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
    };
}

export function PaymentEventDtoToJSON(json: any): PaymentEventDto {
    return PaymentEventDtoToJSONTyped(json, false);
}

export function PaymentEventDtoToJSONTyped(value?: PaymentEventDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventCode': value['eventCode'],
        'newState': value['newState'],
        'payload': value['payload'],
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentMethod': value['paymentMethod'],
        'pspRequestsResponses': ((value['pspRequestsResponses'] as Array<any>).map(PspRequestResponseDtoToJSON)),
        'created': value['created'] == null ? value['created'] : value['created'].toISOString(),
    };
}

